import React from 'react';

import HomeD5 from 'views/Home/HomeD5/HomeD5';
import './HomeD7.scss';

// Design 7: no carrusel de productos; ambas secciones deben renderizar igual (grilla vertical).
const HomeD7 = (props) => <HomeD5 {...props} disableProductCarousel />;

export default HomeD7;
